import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusButton, FileStatusIconProgressing, FileStatusTitle } from '@air/feature-file-status/ui';
import { ChevronDown } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type BoardDeletionTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type DeleteBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<BoardDeletionTask>, 'boardIds'>;
  onCancel: () => void;
};

export const DeleteBoardPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { boardIds } }: DeleteBoardPanelInProgressPanelItemProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing />}
        title={<FileStatusTitle>{`Deleting ${pluralize('board', boardIds.length, true)}`}</FileStatusTitle>}
        buttons={
          <FileStatusButton label="Hide" onClick={onCancel}>
            <ChevronDown className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

DeleteBoardPanelInProgressPanelItem.displayName = 'DeleteBoardPanelInProgressPanelItem';
